import { render, staticRenderFns } from "./OrganizationDeleteModal.vue?vue&type=template&id=bacd54c6&scoped=true"
import script from "./OrganizationDeleteModal.vue?vue&type=script&lang=js"
export * from "./OrganizationDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDeleteModal.vue?vue&type=style&index=0&id=bacd54c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacd54c6",
  null
  
)

export default component.exports